import {gql} from '@apollo/client';

/**
 * Contact vulnerabilities (DBO-766): one row per vulnerability, mirroring
 * Curo's `ahb_vulnerability` entity and the Hubwise investor table.
 */
export const VULNERABILITY_FRAGMENT = gql`
  fragment VulnerabilityFragment on VulnerabilityType {
    id
    curoId
    vulnerabilityType
    serviceLevel
    startDate
    endDate
    status
    isDraft
    isComplete
    isFailedSubmission
    contact {
      id
    }
    pendingEndReview {
      id
    }
  }
`;

export const GET_CONTACT_VULNERABILITIES = gql`
  query ContactVulnerabilities($contactId: UUID!, $reviewId: UUID, $curoSync: Boolean) {
    vulnerabilities(contactId: $contactId, reviewId: $reviewId, curoSync: $curoSync) {
      ...VulnerabilityFragment
    }
  }
  ${VULNERABILITY_FRAGMENT}
`;

export const GET_VULNERABILITY_OPTIONS = gql`
  query VulnerabilityOptions {
    vulnerabilityOptions {
      isEnabled
      vulnerabilityTypes
      serviceLevels
    }
  }
`;

export const UPSERT_VULNERABILITY = gql`
  mutation UpsertVulnerability(
    $vulnerabilityId: UUID
    $contactId: UUID
    $accountId: UUID
    $vulnerabilityType: String!
    $serviceLevel: String!
    $startDate: Date!
    $endDate: Date
  ) {
    upsertVulnerability(
      vulnerabilityId: $vulnerabilityId
      contactId: $contactId
      accountId: $accountId
      vulnerabilityType: $vulnerabilityType
      serviceLevel: $serviceLevel
      startDate: $startDate
      endDate: $endDate
    ) {
      ok
      errors
      vulnerability {
        ...VulnerabilityFragment
      }
    }
  }
  ${VULNERABILITY_FRAGMENT}
`;

export const SAVE_REVIEW_VULNERABILITIES = gql`
  mutation SaveReviewVulnerabilities(
    $reviewId: UUID!
    $contacts: [ContactVulnerabilityDraftInput!]!
  ) {
    saveReviewVulnerabilities(reviewId: $reviewId, contacts: $contacts) {
      ok
      errors
      vulnerabilities {
        ...VulnerabilityFragment
      }
    }
  }
  ${VULNERABILITY_FRAGMENT}
`;
